<template>
  <div class="distributor-box back-fff p20">
    <!--返回按钮-->
    <div class="go-back" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <div class="details_box" v-if="Object.keys(detailObj).length >0">
      <h2 class="title">{{ detailObj.title }}</h2>
      <span class="txt">{{ detailObj.time }}</span>
    </div>
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="435"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {amountHandel, getAllCountrysData} from "@/utils/common";

export default {
  name: "newsListDetails",
  mixins: [Mixin],
  data() {
    return {
      tableLoading: false,
      tableColumns: [
        {
          title: 'SKU',
          key: 'sku',
          align: 'left',
          render(h, params) {
            let ymsSku = params.row._productInfo.ymsSku || '';
            return h('span', ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          key: 'specification',
          align: 'left',
          render: (h, params) => {
            if (params.row._productInfo) {
              let productGoodsSpecifications = params.row._productInfo.productGoodsSpecificationList || [];
              let spec = productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、') || '';
              if (spec) {
                return h('div', {class: 'color-green'}, spec);
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005474'),
          key: 'originalPrice',
          align: 'left',
          render(h, params) {
            let countryName = params.row.countryName;
            let originalPrice = params.row.originalPrice;
            return h('span', countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005475') + amountHandel(originalPrice));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005476'),
          key: 'currentPrice',
          align: 'left',
          render(h, params) {
            let countryName = params.row.countryName;
            let currentPrice = params.row.currentPrice;
            return h('span', countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005475') + amountHandel(currentPrice));
          }
        }
      ],
      tableData: [],
      detailObj: {}
    };
  },
  created() {
    this.getYmsProductNotice();
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/newsList');
    },
    // 获取商品通知详情的数据
    getYmsProductNotice() {
      let v = this;
      let ymsProductGoodsIds = [];
      let ymsReceiveStationNotificationLogId = v.$route.query.ymsReceiveStationNotificationLogId;
      v.tableLoading = true;
      v.axios.get(api.get_ymsDistributorStationNotification + ymsReceiveStationNotificationLogId).then((response) => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data.ymsStationNotificationExtends) {
            data.ymsStationNotificationExtends.map((item) => {
              item[item.extendKey] = item.value;
              if (item.extendContentJson) {
                let newList = JSON.parse(item.extendContentJson) || [];
                if (newList.length > 0) {
                  newList.map((ele) => {
                    if (ele.ymsProductGoodsId) {
                      ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                    }
                  });
                  if (ymsProductGoodsIds.length > 0) {
                    (async () => {
                      let list = await v.getProductInfoByIds(ymsProductGoodsIds, newList, false, false, false);
                      let countrysData = await getAllCountrysData('cn', true);
                      list.map((k) => {
                        k.countryName = '';
                        countrysData.map((j) => {
                          if (j.twoCode === k.countryCode) {
                            k.countryName = j.name;
                          }
                        });
                      });
                      v.tableData = list;
                    })();
                  }
                }
              }
            });
          }
          data.time = v.$uDate.dealTime(data.updatedTime, 'fulltime');
          v.detailObj = data;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.details_box {
  padding: 10px 0 15px 0;
  border-bottom: 1px solid #dcdee2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  .title {
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }

  .txt {
    color: #666;
    font-size: 14px;
    margin-left: 30px;
  }
}
</style>
